@if (isLoading) {
    <generic-skeleton></generic-skeleton>
} @else {
    <pega-mijn
        (assignmentNameChanged)="onAssignmentNameChanged($event)"
        (caseChange)="onCaseChange($event)"
        (caseTypeChange)="onCaseTypeChange($event)"
        (loadAction)="onLoadAction($event)"
        (onAssignmentComplete)="onAssignmentComplete($event)"
        [actionID]="pegaResumeActionID"
        [assignmentID]="pegaResumeAssignmentID"
        [breadcrumb]="apPegaMijnBreadcrumb"
        [business]="apPegaMijnBusiness"
        [caseID]="pegaResumeCaseID"
        [caseTypeID]="caseTypeID"
        [closeUrl]="apPegaCloseUrl"
        [content]="pegaContent"
        [initWithSubmit]="pegaResumeInitWithSubmit"
        [pegaExtraHeaders]="pegaExtraHeaders"
        [showErrorCloseButton]="apPegaErrorShowCloseButton"
        [templateType]="apPegaMijnTemplateType"
        [title]="starterAppTitle"
        [useState]="apPegaUseState"
        [webcomponentIdentifier]="webcomponentIdentifier"
        data-bb="pega-mijn"
    ></pega-mijn>
}
